import React, { useEffect } from "react";
import { authWithPiNetwork, CreatePayment } from "../utils/PiIntegration";
import { useParams } from "react-router-dom";

type Props = {};

export default function AutoDonatePage({}: Props) {
  const params = useParams();
  const amount = params.amount;
  const [message, setMessage] = React.useState("Donating...");
  useEffect(() => {
    const donate = async () => {
      const user = await authWithPiNetwork();
      if (user?.data?.userUid) {
        CreatePayment(
          user.data.userUid,
          Number(amount ?? 10),
          "donation",
          () => {
            setMessage("Donation processed successfully!!!!, Thank you.");
          }
        );
      } else {
        setMessage("User authentication failed.");
      }
    };
    donate();
  }, [amount]);

  return <div>{message && <p>{message}</p>}</div>;
}
